import type { ReactElement } from 'react'
import { useT } from '../i18n/useI18n'
import { company, formatOrgNumber } from '../data/company'

/** "Org.nr. 991 851 607 MVA" — the VAT suffix follows company.vatRegistered. */
export default function OrgNumber(): ReactElement {
  const t = useT()
  return <>{t(company.vatRegistered ? 'company.orgNumberVat' : 'company.orgNumber', { number: formatOrgNumber(company.orgNumber) })}</>
}
